import React, { forwardRef, Ref } from 'react';
import { IconProps } from './interface';
import { toPascalCase } from '../_utils';
import * as Icons from './icons';

const iconNames = ['success', 'direction-bottom'];

const Icon = forwardRef((props: IconProps, ref: Ref<SVGSVGElement>) => {
  const { name, ...iconProps } = props;

  if (!iconNames.includes(name)) {
    return null;
  }

  const IconComponent = (Icons as Record<string, React.ComponentType<any>>)[`${toPascalCase(name)}Icon`];

  if (!IconComponent) {
    return null;
  }

  return <IconComponent ref={ref} {...iconProps} />;
});

export default Icon;
export * from './interface';
